import { titleCase } from './SqliteHelp.js'
export function makeElementCode(dbName, tableName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));

    let filedListCode = ``
    tableDatas[tableName].forEach(tableItem => {
    if (tableItem.name != 'id') {
        filedListCode = filedListCode + `
                  Container(
                    padding: EdgeInsets.fromLTRB(8, 2, 8, 2),
                    child: Row(
                      children: [
                        Expanded(
                          flex: 1,
                          child: Container(
                            alignment: Alignment.bottomLeft,
                            child: Text.rich(
                              TextSpan(
                                children: [
                                  TextSpan(text: "${titleCase(tableItem.epithet??tableItem.name)}",style: TextStyle(color: Colors.black87,fontSize: 12)),
                                ]
                              )
                            )
                          )
                        ),
                        Expanded(
                          flex: 1,
                          child: Container(
                            alignment: Alignment.bottomLeft,
                            child: Text.rich(
                              TextSpan(
                                children: [
                                  TextSpan(text: "${titleCase(tableItem.name)}",style: TextStyle(color: Colors.black54,fontSize: 12)),
                                ]
                              )
                            )
                          )
                        ),
                        Expanded(
                          flex: 1,
                          child: Container(
                            alignment: Alignment.bottomLeft,
                            child: Text.rich(
                              TextSpan(
                                children: [
                                  TextSpan(text: widget.dataForm["${tableItem.name}"] != null ? widget.dataForm["${tableItem.name}"].toString() : '',style: TextStyle(color: Colors.black54,fontSize: 12)),
                                ]
                              )
                            )
                          )
                        ),
                      ],
                    )
                  ),`
    }
    })

    return `/// Author: Samle
import 'package:flutter/material.dart';

class ${titleCase(tableName)}Element extends StatefulWidget {
  /// 传入参数
  const ${titleCase(tableName)}Element({
    Key? key,
    required this.onPressed,
    required this.doublePressed,
    required this.longPressed,
    required this.onTap,
    required this.dataForm,
  }) : super(key: key,);
  final Map dataForm;
  final VoidCallback onPressed;
  final VoidCallback doublePressed;
  final VoidCallback longPressed;
  final VoidCallback onTap;
  @override
  State<StatefulWidget> createState() => ${titleCase(tableName)}ElementState();
}
class ${titleCase(tableName)}ElementState extends State<${titleCase(tableName)}Element> {
  
  @override
  Widget build(BuildContext context) {
    return Stack(
      alignment:Alignment.center , /// 指定对齐方式为居中
      children: <Widget>[          /// 子组件列表
        Positioned(                /// 不指定任何参数时则放在Stack对齐方式指定的位置
          child: InkWell(
            onTap: (){ widget.onPressed(); },
            onDoubleTap: (){ widget.doublePressed(); },
            onLongPress: (){ widget.longPressed(); },
            child: Container(
              padding: EdgeInsets.fromLTRB(8, 4, 8, 4),
              decoration: BoxDecoration(
                border:  Border(bottom:BorderSide(width: 1,color: Color(0xffe5e5e5)) ),
              ),
              child: Column(
                children: [
                  ${filedListCode}
                ]
              )
            )
          ),
        ),
        /// Positioned(
          /// right: 15,
          /// top: 0,
          /// child: Container(
            /// child: Text(""),
            /// decoration: BoxDecoration(
              /// borderRadius: BorderRadius.only(
                /// bottomLeft: Radius.circular(5.0),
                /// bottomRight: Radius.circular(5.0)
              /// ),
            /// ),
            /// padding: EdgeInsets.fromLTRB(3, 2, 3, 4),
          /// ),
        /// ),
      ],
    );
  }
    
}

`
}